// NOTE: Prefer adding new error codes to the shared package instead of this file:
// packages/common-models/src/feature/collaboration/constants/custom_error_codes.constants.ts
// This keeps error codes in sync between FE and BE without duplication.
export enum CustomErrorCodes {
  NOT_IN_COURSE = 1000,
  CANT_ACCESS_QUESTION = 1001,
  ACCOUNT_NOT_SIGNED_UP = 1002,
  EMAIL_NOT_IN_TOKEN = 1003,
  FB_EMAIL_NOT_IN_TOKEN = 1004,
  CLIENT_VERSION_UPDATE_NEEDED = 1005,
  CANNOT_CLONE_SPACE_TEMPLATE = 1006,
  SPACE_IS_NOT_TEMPLATE = 1007,
  BYPASS_ERROR_INTERCEPTOR = 9999,

  // #region WR / RA / GL error codes
  REQUEST_ALREADY_APPROVED = 1015,
  WR_DISABLED_IN_SPACE = 1016,
  USER_HAS_NO_ACCESS_TO_SPACE = 1017,
  USER_IS_ALREADY_HOST = 1018,

  GUESTS_NOT_ALLOWED_TO_PRIVATE_SPACES = 1019,

  NOT_PRIVATE_SPACE = 1020,
  ALREADY_HAVE_ACCESS_TO_SPACE = 1021,
  // #endregion
}

export enum CustomErrorMessages {
  SPACE_NOT_FOUND = 'Space not found',
  INVALID_SPACE_ID = 'Invalid space id',
}
